const Visatronix = () => {
    return (
        
        <div>
            <div className="">
                <img src="/ExpressBanner/banner-7.jpg" width="100%"/>
            </div>
            <div className="flex flex-col justify-center items-center mb-[1.5rem]">
                <hr className="w-[52rem]"/>
                <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">

                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold text-3xl text-[#373737]">
                            Visatronix
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            With the mission of becoming the market leader by virtue of becoming the most
                            trusted name in Visa Drop Box Services, TCS Visatronix extends drop box facilities
                            for visa applicants in work, visit, study, and family-reunion categories for applicants all over Pakistan.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            To offer further convenience, applications are booked on a ‘Return Service Basis’ at selected TCS Express 
                            Centres located in all major cities of Pakistan. The ever increasing list of destinations currently serves:
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            Egypt, Greece, India, Italy, Malaysia, Malta, South Africa, Spain, Thailand and Tunisia.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            TCS Visatronix provides a hassle-free, one window, visa dropbox and value-added visa facilitation 
                            services. Operating from eleven major cities of Pakistan, with a dedicated team of courteous and 
                            experienced visa services officers, this service manages over 100,000 visa applications annually.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            Fully equipped with Quality Management System for efficient and secure handling of applications, 
                            documents and managing queues, without the involvement of any third-party at any stage of the 
                            process, our Visa Application Centers are guarded round the clock. This helps participating missions 
                            and consulates to minimise the costs while doing away with added administrative and security 
                            arrangements required to deal with applicants’ queues at their own premises.
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            Applicants’ waiting lounges are furnished with comfortable seating and television screens, 
                            with dedicated counters for senior citizens and the people with special needs. Document scanning, 
                            photocopying, faxing, printing, emailing and biometric data verification facilities are all provided 
                            under one roof. Applicants are kept informed about their application status through SMS alerts, whereas 
                            our helplines provide further assistance.
                        </p>
                    </div>
                    <div className="flex-1 flex flex-col justify-center items-center">
                        <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
                    </div>
                </div>
      
            </div>
        </div>
       
    )
};
export default Visatronix;